import { Button } from '@/components/ui/button';

import { AppShell } from '../app-shell';

export function NoRecentApplicationPage() {
  return (
    <AppShell>
      <div className="stack">
        <p className="eyebrow">Thanks for your interest!</p>
        <h1>MAS has many exciting opportunities!</h1>
        <hr className="divider" />
        <p>
          <strong>We do not have any new job applications on file for you.</strong>
        </p>
        <p>
          Please visit our job board to browse all of the latest job openings. When you find a job
          that is right for you, simply apply online and login with your MAS account to continue
          your application.
        </p>
        <div>
          <Button
            onClick={() =>
              window.open('https://jobs.masmedicalstaffing.com/', '_blank', 'noopener')
            }
          >
            Explore Jobs
          </Button>
        </div>
        <p className="muted">
          If you believe you have received this message in error, please reach out to your MAS
          recruiter.
        </p>
      </div>
    </AppShell>
  );
}
